<template>
  <div class="nav">
    <div class="line flex_row">
      <p class="line_left"></p>
      <p class="line_right"></p>
    </div>

    <div class="nav_logo flex_row">
      <div class="logo_box">
        <img style="width: 262px;" src="../../assets/qingye/LOGO.png" />
      </div>
      <div class="nav_header_right flex_row">
        <div class="right flex_row animated bounce">
          <img src="../../assets/phone_icon.png" />
          <div class="phone">
            <p style="color: #232323; font-size: 14px">欢迎联系我们</p>
            <p style="font-size: 24px; color: #1b63a7; font-weight: 500">
              0592-2082091
            </p>
          </div>
        </div>
        <div class="nav_user">
          <el-dropdown v-if="isLogged" trigger="click" @command="handleUserCommand">
            <div class="nav_user_trigger">
              <span class="nav_user_avatar">
                <i class="el-icon-user-solid"></i>
              </span>
              <span class="nav_user_name">{{ maskedPhone }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="nav_btn_box flex_row hoverName navClass">
      <div class="flex_row" style="width: 80%; justify-content: space-around">
        <div :class="$store.state.tabbar == index ? 'btn_li active' : 'btn_li'" v-for="(item, index) in navList"
          :key="index">
          <p @click="openNav(index)">{{ item }}</p>
        </div>
      </div>
      <div class="navClass_about">
        <el-dropdown trigger="click" @visible-change="handleChange" @command="handleCommand">
          <div :class="this.show == true ? 'navClassActive navClassTextActive' : ''
            " class="navClass_about_text">
            关于我们<i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in dropdownList" :key="index" :command="item.path">{{ item.name
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="navClass_Token">
        <el-dropdown trigger="click" @visible-change="onTokenMenuVisibleChange" @command="onTokenSelect">
          <div :class="this.isTokenMenuOpen == true ? 'navClassActive navClassTextActive' : ''
            " class="navClass_Token_text">
            青词元<i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in tokenDropdownList" :key="index" :command="item.path">{{ item.name
              }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <LoginDialog :visible.sync="loginVisible" @register="handleOpenRegister"></LoginDialog>
    <RegisterDialog :visible.sync="registerVisible" @login="handleOpenLogin" @success="handleOpenLogin"></RegisterDialog>
  </div>
</template>
<script>
import LoginDialog from "./LoginDialog";
import RegisterDialog from "./RegisterDialog";

export default {
  name: "navBar",
  components: {
    LoginDialog,
    RegisterDialog
  },
  data() {
    return {
      Index: 0,
      navList: ["首页", "案例展示", "解决方案", "技术服务", "企业动态"],
      dropdownList: [
        {
          name: "公司简介",
          path: "/Community/CompanyProfile",
          imgSrc: require("../../assets/qingye/Aboutus.png"),
        },
        {
          name: "荣誉资质",
          path: "/Community/HonoraryCertificate",
          imgSrc: require("../../assets/noContent.png"),
        },
        {
          name: "下载中心",
          path: "/Community/DataDownload",
          imgSrc: require("../../assets/qingye/1102.png"),
        },
        {
          name: "联系我们",
          path: "/Community/ContactUs",
          imgSrc: require("../../assets/qingye/Contactus.png"),
        },
      ],
      tokenDropdownList: [
        {
          name: "token平台",
          path: "/Token/CompanyProfile",
          imgSrc: require("../../assets/qingye/AiServices.png"),
        },
        {
          name: "AI视频生成",
          path: "/Token/AIVideo",
          imgSrc: require("../../assets/qingye/AiServices.png"),
        },
        {
          name: "AI漫剧生成",
          path: "/Token/AIComic",
          imgSrc: require("../../assets/qingye/AiServices.png"),
        },
        {
          name: "去水印平台",
          path: "/Token/WatermarkRemoval",
          imgSrc: require("../../assets/qingye/AiServices.png"),
        },
        {
          name: "音乐生成平台",
          path: "/Token/MusicGeneration",
          imgSrc: require("../../assets/qingye/AiServices.png"),
        },
        {
          name: "算力平台",
          path: "/Token/ComputingPower",
          imgSrc: require("../../assets/qingye/AiServices.png"),
        },
      ],
      pathList: [],
      show: false,
      isTokenMenuOpen: false,
      loginVisible: false,
      registerVisible: false,
      // 路由映射配置
      routeMap: {
        0: "/",
        1: "/ParkKeeper",
        2: "/BusinessCooperation",
        3: "/service",
        4: "/ParkOverview",
        6: "/MoreWords"
      },
    };
  },
  computed: {
    isLogged() {
      return this.$store.getters["auth/isLogged"];
    },
    loginPromptSeq() {
      return this.$store.getters["auth/loginPromptSeq"];
    },
    userInfo() {
      return this.$store.getters["auth/userInfo"];
    },
    maskedPhone() {
      const phone = this.userInfo && this.userInfo.phone ? String(this.userInfo.phone) : "";
      if (!phone) return "已登录";
      return phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
    },
  },
  watch: {
    loginPromptSeq(seq) {
      if (!seq) return;
      this.$nextTick(() => {
        this.handleOpenLogin();
      });
    }
  },
  mounted() { },
  methods: {
    //切换nav
    openNav(index) {
      index = index.toString();
      this.$cookies.set("tabbar", index);
      this.$store.state.tabbar = this.$cookies.get("tabbar");
      const route = this.routeMap[index];
      if (route) {
        if (index === 1) {
          this.$cookies.set("tab1", "1");
        }
        this.$router.push(route);
      }
    },
    // 获取点击的路径
    handleCommand(command) {
      this.$router.push({
        path: command,
      });
      this.$emit("handlePath", command, this.dropdownList);
    },
    // 判断下拉菜单是否打开
    handleChange(isChange) {
      if (isChange == true) {
        this.show = true;
        this.$store.state.tabbar = null;
      } else {
        this.show = false;
      }
    },
    // 判断青词元下拉菜单是否打开
    onTokenMenuVisibleChange(visible) {
      if (visible == true) {
        this.isTokenMenuOpen = true;
        this.$store.state.tabbar = null;
      } else {
        this.isTokenMenuOpen = false;
      }
    },
    // 获取点击的路径
    onTokenSelect(select) {
      this.$router.push({
        path: select,
      });
    },
    handleUserCommand(command) {
      if (command === "logout") {
        this.$store.dispatch("auth/logout");
        this.$message.success("已退出登录");
      }
    },
    //给父级页面调用：打开全局登录弹窗
    openLoginDialog() {
      this.handleOpenLogin();
    },
    handleOpenLogin() {
      this.registerVisible = false;
      this.loginVisible = true;
    },
    handleOpenRegister() {
      this.loginVisible = false;
      this.registerVisible = true;
    },
  },
};
</script>
<style scoped>
.nav {
  /*max-width: 1920px;*/
  height: 190px;
  margin: 0 auto;
  min-width: 1200px;
  /*background: orange;*/
}

.line {
  height: 7px;
  width: 100%;
}

.line_left {
  height: 7px;
  width: 60%;
  background: #1b63a7;
}

.line_right {
  width: 40%;
  background: #000000;
}

.nav_logo {
  /*width: 990px;*/
  width: 1200px;
  /*background: yellow;*/
  margin: 0 auto;
  margin-top: 16px;
  justify-content: space-between;
}

.nav_logo .right {
  align-items: center;
}

.nav_logo .right .phone {
  margin-left: 20px;
}

.nav_logo .right img {
  width: 37px;
  height: 28px;
}

.logo_box {
  width: 405px;
  height: 70px;
}

.logo_box img {
  width: 100%;
  height: 100%;
}

.nav_header_right {
  align-items: center;
}

.nav_user {
  margin-left: 28px;
}

.nav_user_trigger {
  display: flex;
  align-items: center;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #e5e5e5;
  border-radius: 18px;
  background: #ffffff;
  cursor: pointer;
}

.nav_user_avatar {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  border-radius: 50%;
  color: #ffffff;
  background: #1b63a7;
}

.nav_user_avatar i {
  font-size: 13px;
}

.nav_user_name {
  font-size: 13px;
  color: #333333;
}




.nav_btn_box {
  width: 1200px;
  margin: 0 auto;
  margin-top: 36px;
  /*background: yellowgreen;*/
}

.nav_btn_box .btn_li {
  width: 94px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  /*margin-left: 22px;*/
  margin-right: 22px;
  transform: skew(-15deg);
  color: #333333;
}

.active {
  background: #1b63a7;
  font-weight: bold;
  color: white !important;
}

.nav_btn_box .btn_li p {
  transform: skew(15deg);
  font-size: 19px;
}

.hoverName:hover {
  cursor: pointer;
}

.navClass {
  display: flex;
  align-items: center;
}

.navClass_about {
  /*padding-left: 25px;*/
  width: 110px;
  height: 34px;
  margin: 0 22px;
}

.navClass_about_text {
  font-size: 19px;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 34px;
  color: #333333;
}

.navClass_Token {
  width: 110px;
  height: 34px;
  margin: 0 22px;
}

.navClass_Token_text {
  font-size: 19px;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 34px;
  color: #333333;
}

.navClassActive {
  width: 94px;
  height: 34px;
  line-height: 34px;
  background: #2968bd;
  transform: skew(-15deg);
  color: white;
  text-align: center;
}

.navClassTextActive {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/components/navBar.vue